import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './state';
import { listTemplates, loadTemplate } from './thunks/templates';
import { getArtworkFile, downloadArtworkPdf, getEditorUrl, loadArtwork } from './thunks/artwork';
import { saveDocument, exportDocument, refreshDocument } from './thunks/documents';
import { artworksReducer } from './extra-reducers/artworks';
import { templatesReducer } from './extra-reducers/templates';
import { selectTemplateReducer, toggleSavingArtworkReducer, toggleLoadingDocumentReducer } from './reducers';

export {
  downloadArtworkPdf,
  exportDocument,
  getArtworkFile,
  getEditorUrl,
  listTemplates,
  loadArtwork,
  loadTemplate,
  refreshDocument,
  saveDocument,
};

export const artworkSlice = createSlice({
  name: 'artworks',
  initialState,
  reducers: {
    selectTemplate: selectTemplateReducer,
    toggleLoadingDocument: toggleLoadingDocumentReducer,
    toggleSavingArtwork: toggleSavingArtworkReducer,
  },
  extraReducers(builder) {
    artworksReducer(builder);
    templatesReducer(builder);
  },
});

export const { selectTemplate, toggleLoadingDocument, toggleSavingArtwork } = artworkSlice.actions;

export default artworkSlice.reducer;
